import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { ForumComment } from '~/api/forum/types';

import { Button } from '~/components';
import { Form } from '~/components/Form';

import type { ForumCommentFieldValues } from './ForumCommentEditorField';

import { ForumCommentEditorField } from './ForumCommentEditorField';
import { formButtonsStyle, formStyle } from './ForumCommentForm.css';

type Props = {
  comment: ForumComment;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (data: ForumCommentFieldValues) => void;
};

export const EditForumCommentForm = ({ comment, loading, onCancel, onSubmit }: Props) => {
  const { control, handleSubmit } = useForm<ForumCommentFieldValues>({
    defaultValues: {
      content: comment.content,
    },
  });

  const { t } = useTranslation(['common']);

  return (
    <Form className={formStyle} onSubmit={handleSubmit(onSubmit)}>
      <ForumCommentEditorField autofocus="end" control={control} />

      <div className={formButtonsStyle}>
        <Button emphasis="secondary" onClick={onCancel} type="button">
          {t('common:actions.cancel')}
        </Button>

        <Button icon="Save" loading={loading} type="submit">
          {t('common:actions.save')}
        </Button>
      </div>
    </Form>
  );
};
